import { useEffect, useState } from 'react';
import { PromoSidebar } from './PromoSidebar';

// Matches Tailwind's `sm` (640px) and `lg` (1024px) breakpoints used below.
const getBreakpoint = () => {
  if (typeof window === 'undefined') return 'mobile';
  if (window.matchMedia('(min-width: 1024px)').matches) return 'desktop';
  if (window.matchMedia('(min-width: 640px)').matches) return 'tablet';
  return 'mobile';
};

const AuthLayout = ({ children }) => {
  // Only one of the three layout blocks below is visible at a time (via
  // Tailwind's `hidden` classes), but {children} (the Login form) must only
  // ever be *mounted* once too - otherwise it triple-mounts hooks like
  // useGoogleOneTapLogin and duplicates DOM ids (#email/#password) across
  // all three hidden copies, which can leave stray elements intercepting
  // taps. `breakpoint` tracks which block is actually visible so children
  // renders in exactly one of them.
  const [breakpoint, setBreakpoint] = useState(getBreakpoint);

  useEffect(() => {
    const mqTablet = window.matchMedia('(min-width: 640px)');
    const mqDesktop = window.matchMedia('(min-width: 1024px)');
    const update = () => setBreakpoint(getBreakpoint());

    update();
    mqTablet.addEventListener('change', update);
    mqDesktop.addEventListener('change', update);
    return () => {
      mqTablet.removeEventListener('change', update);
      mqDesktop.removeEventListener('change', update);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#4338ca] relative">
      {/* Add grid overlay */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `
                        linear-gradient(#503CDA 1px, transparent 1px),
                        linear-gradient(90deg, #503CDA 1px, transparent 1px)
                    `,
          backgroundSize: '80px 80px',
        }}
      />

      <div className="sm:hidden">
        <div className="flex flex-col min-h-screen">
          <div className="flex-1 px-4 py-8 text-center">
            <PromoSidebar isMobile={true} />
          </div>
          <div>
            <div className="w-full">{breakpoint === 'mobile' && children}</div>
          </div>
        </div>
      </div>

      <div className="hidden sm:flex lg:hidden flex-col items-center justify-center min-h-screen px-8 py-8">
        <div className="w-full max-w-2xl">
          {/* Top Promo Content for Tablet - Logo and title only */}
          <div className="mb-8 text-center">
            <PromoSidebar isTabletTop={true} />
          </div>

          {/* Login Form */}
          <div className="flex justify-center mb-8">
            <div className="w-full max-w-md">{breakpoint === 'tablet' && children}</div>
          </div>

          {/* Bottom Promo Content for Tablet - Bullets and exam icons */}
          <div className="text-center">
            <PromoSidebar isTabletBottom={true} />
          </div>
        </div>
      </div>

      {/* Desktop Layout - Side by side */}
      <div className="hidden lg:flex lg:items-center lg:justify-center lg:min-h-screen">
        <div className="max-w-[1200px] flex gap-20">
          <PromoSidebar />
          <div className="flex-1 lg:w-[550px] flex items-center justify-center">
            {breakpoint === 'desktop' && children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
